/* eslint-disable react/no-children-prop */
import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { updatePwdUsers } from "../../../Services/UsersService";
import { FullWideNotification } from '../../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

const renderTextField = ({
  input, label, meta: { touched, error }, children,
}) => (
  <TextField
    className="material-form__field"
    label={label}
    error={touched && error}
    children={children}
    value={input.value}
    onChange={(e) => {
      e.preventDefault();
      input.onChange(e.target.value);
    }}
  />
);

renderTextField.propTypes = {
  input: PropTypes.shape().isRequired,
  label: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  children: PropTypes.arrayOf(PropTypes.element),
};

renderTextField.defaultProps = {
  meta: null,
  label: '',
  children: [],
};

class ProfileSettings extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      data: {
        newPassword: '',
        phone: '',
        email: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }

    if(data.email === undefined || data.email === null || data.email === '' ||
        data.phone === undefined || data.phone === null || data.phone === '' ){
          this.show('warning', this.props.t('forms.requiredFields'));
        return false;
    }
    let user = this.props.user;
    user.email = data.email;
    user.phone = data.phone;
    user.passwordChanged = 0;

    if(data.newPassword !== null && data.newPassword !== undefined && data.newPassword !== ''){
      if(user.password !== data.newPassword){
        user.password = data.newPassword;
        user.passwordChanged = 1;
      }
    }    

    updatePwdUsers(user)
      .then(obj => {
        if(obj !== null && obj !== undefined && obj.error === undefined){
          if(obj.erros.length === 0){
            this.show('success', this.props.t('forms.dataUpdateSuccess'));
            this.props.user.password = obj.password;
          }else{
            if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
              for(let i = 0; i < obj.erros.length; i++){
                this.show('danger', this.props.t('erros.'+obj.erros[i]));
              }
            }
          }
        } else {
          this.show('danger', this.props.t('forms.dataCreateError'));
        }
      });
  }

  componentDidMount() {
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(prevProps) {
    if(prevProps.user !== this.props.user && 
      this.props.user !== undefined && this.props.user !== null && this.props.user.id > 0){
      let obj = {};
      obj.newPassword = '';
      obj.phone = this.props.user.phone;
      obj.email = this.props.user.email;
      this.setState({ data: obj});
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value;
    this.setState({ data });
  }

  clear(){
    const data = { ...this.state.data }
    data['newPassword'] = '';
    data['phone'] = this.props.user.phone;
    data['email'] = this.props.user.email;
    this.setState({ data });
  }

  cancel(event) {
    this.clear();
  }

  render() {
    const { handleSubmit, t } = this.props;

    return (
      <form className="material-form" onSubmit={handleSubmit}>
        <div>
          <span title={t('forms.requiredField')} className="material-form__label">
            {t('forms.email')} <span style={{color: "#ff0000"}}>*</span>
          </span>
          <div style={{display: "none"}}>
            <Field
              type="hidden"
              name="id"
              component={renderTextField}
            />
          </div>
          <div className="MuiFormControl-root MuiTextField-root material-form__field">
            <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
              <input aria-invalid="false" 
                type="text" 
                name="email"
                className="MuiInputBase-input MuiInput-input"
                value={this.state.data.email}
                onChange={e => this.updateField(e)}
              />
            </div>
          </div>
        </div>
        <div>
          <span title={t('forms.requiredField')} className="material-form__label">
            {t('forms.phone')} <span style={{color: "#ff0000"}}>*</span>
          </span>
          <div className="MuiFormControl-root MuiTextField-root material-form__field">
            <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
              <input aria-invalid="false" 
                type="phone" 
                name="phone"
                className="MuiInputBase-input MuiInput-input"
                value={this.state.data.phone}
                onChange={e => this.updateField(e)}
              />
            </div>
          </div>
        </div>
        <div>
          <span className="material-form__label">{t('forms.password')}</span>
          <div className="MuiFormControl-root MuiTextField-root material-form__field">
            <div className="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl">
              <input aria-invalid="false" 
                type="password" 
                name="newPassword"
                className="MuiInputBase-input MuiInput-input"
                value={this.state.data.newPassword}
                onChange={e => this.updateField(e)}
                autoComplete="new-password"
              />
            </div>
          </div>
        </div>
        <ButtonToolbar className="form__button-toolbar">
          <Button color="primary" type="submit" onClick={e => this.handleSubmit(e)}>
          {t('forms.save')}
          </Button>
          <Button type="button" onClick={e => this.cancel(e)}>
          {t('forms.cancel')}
          </Button>
        </ButtonToolbar>
      </form>
    );
  }
}

export default reduxForm({
  form: 'profile_settings_form',
})(withTranslation('common')(ProfileSettings));
